import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { statusProject } from './pr-project-progress-badge/pr-project-progress-badge.component';
export interface ProjectStade {
  name: string;
  status: statusProject;
}

export const initialStades: ProjectStade[] = [
  { name: 'Création', status: statusProject.WAITING },
  { name: 'Instruction', status: statusProject.WAITING },
  { name: 'Envoi banque', status: statusProject.WAITING },
  { name: 'Accord banque', status: statusProject.WAITING },
  { name: 'Accord client', status: statusProject.WAITING },
  { name: 'Édition des offres', status: statusProject.WAITING },
  { name: 'Acceptation des offres', status: statusProject.WAITING },
];

@Component({
    selector: 'pr-project-progress',
    templateUrl: './pr-project-progress.component.html',
    styleUrls: ['./pr-project-progress.component.scss'],
    standalone: false
})
export class PrProjectProgressComponent implements OnInit {
  projectStades: ProjectStade[] = [...initialStades];
  annule: boolean = false;
  @Input() stadeDossier: number = 1;
  @Input() loading: boolean = true;
  ngOnInit() {
    this.updateProjectStades(this.stadeDossier);
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes.stadeDossier) {
      this.updateProjectStades(changes.stadeDossier.currentValue);
    }
  }
  updateProjectStades(currentStage: number) {
    if (currentStage === 10) {
      this.annule = true;
    }
    this.projectStades.forEach((stade, index) => {
      if (index < currentStage - 1) {
        stade.status = statusProject.VALIDATED;
      } else if (index === currentStage - 1) {
        stade.status = statusProject.IN_PROGRESS;
      } else {
        stade.status = statusProject.WAITING;
      }
    });
  }
}
